import { PlacesApiError } from './erros/places_service_error';
import {
  IPlacesApiAdapter,
  PlaceDetails,
  PlacesApiAcceptedFields,
  PlacesApiAdditionalOptions,
  PlaceSuggestion,
  PredictParams,
} from './types';

export class PlacesApiClient {
  private readonly adapter: IPlacesApiAdapter;

  private readonly acceptedFields: PlacesApiAcceptedFields[] = ['location'];

  constructor(adapter: IPlacesApiAdapter) {
    this.adapter = adapter;
  }

  suggestPlaces(params: PredictParams): Promise<PlaceSuggestion[]> {
    return this.adapter.suggestPlaces(params.input);
  }

  searchPlaces(input: string, options?: PlacesApiAdditionalOptions): Promise<PlaceDetails[]> {
    this.checkAcceptedFields(options?.fields);

    return this.adapter.searchPlaces(input, options);
  }

  getPlaceDetails(placeId: string, options?: PlacesApiAdditionalOptions): Promise<PlaceDetails> {
    this.checkAcceptedFields(options?.fields);

    return this.adapter.getPlaceDetails(placeId, options);
  }

  private checkAcceptedFields(fields?: PlacesApiAcceptedFields[]): void {
    if (!fields) return;

    if (!Array.isArray(fields)) {
      throw new PlacesApiError('Fields must be an array');
    }

    const invalidFields = fields.filter((field) => !this.acceptedFields.includes(field));

    if (invalidFields.length === 0) return;

    throw new PlacesApiError(`Invalid fields: ${invalidFields.join(', ')}`);
  }
}

export * from './types';
